import {IForm} from '@/components/types'
import {useSearchDateShortcut} from "@/hooks/useSearch";

const shortcuts = useSearchDateShortcut()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'empId',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    },
    {
      field: 'deptId',
      type: 'select',
      label: '所属部门',
      clearable: true,
      placeholder: '请选择部门'
    },
    {
      field: 'empTag',
      type: 'select',
      label: '员工标签',
      clearable: true,
      placeholder: '请选择员工标签',
      options: [
        {title: '全部', value: ''},
        {title: '518', value: '0'},
        {title: '投教', value: '1'}
      ]
    },
    {
      field: 'useStatus',
      type: 'select',
      label: '使用状态',
      clearable: true,
      placeholder: '请选择使用状态',
      options: [
        {title: '全部', value: ''},
        {title: '未使用', value: '0'},
        {title: '已使用', value: '1'},
        {title: '已失效', value: '2'}
      ]
    },
    {
      field: 'createdTimeSlot',
      type: 'datepicker',
      label: '获取时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    {
      label: '活动名称',
      field: 'raffleName',
      type: 'input',
      clearable: true,
      placeholder: '请输入活动名称'
    },
    {
      field: 'useTimeSlot',
      type: 'datepicker',
      label: '中奖时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    }
  ]
}
